import _ from 'lodash';

export const deepEquals = (obj1, obj2) => _.isEqual(obj1, obj2);



// WEBPACK FOOTER //
// ./src/utils/deep-equals.js